"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const V = (_param)=>{
    var { color: l, size: a = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = s(), h = l !== null && l !== void 0 ? l : n ? t.colors.inverse : t.colors.neutralHigh, { skinName: i } = c();
    return i.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: h,
                d: "M19.86 4.14h-3.213V2.712a.714.714 0 0 0-1.426 0V4.14H8.789V2.713a.714.714 0 0 0-1.427 0V4.14H4.144C2.964 4.14 2 5.1 2 6.283V22h20V6.283a2.143 2.143 0 0 0-2.14-2.144m.714 16.43H3.43V10.21h17.143zM3.43 8.783v-2.5c0-.394.32-.714.713-.714h3.214v1.427a.714.714 0 0 0 1.426 0V5.57h6.427v1.427a.714.714 0 0 0 1.427 0V5.57h3.213c.393 0 .713.32.713.713v2.501z"
            }),
            /* @__PURE__ */ r("path", {
                fill: h,
                d: "M8.34 16.103h.426a4.11 4.11 0 0 0 4.04 3.392c.719 0 1.427-.192 2.053-.553a.712.712 0 1 0-.713-1.235 2.675 2.675 0 0 1-3.918-1.604h2.757a.714.714 0 0 0 0-1.426H10.23a2.685 2.685 0 0 1 2.578-1.966c.466 0 .928.123 1.34.361a.717.717 0 0 0 .717-1.239 4.1 4.1 0 0 0-2.053-.553 4.11 4.11 0 0 0-4.04 3.392h-.426a.714.714 0 0 0-.713.713c0 .393.315.718.709.718"
            })
        ]
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: h,
                d: "M19.86 4.14h-3.213V2.712a.714.714 0 0 0-1.426 0V4.14H8.789V2.713a.714.714 0 0 0-1.427 0V4.14H4.144C2.964 4.14 2 5.1 2 6.283V22h20V6.283a2.143 2.143 0 0 0-2.14-2.144m.714 16.43H3.43V10.21h17.143zM3.43 8.783v-2.5c0-.394.32-.714.713-.714h3.214v1.427a.714.714 0 0 0 1.426 0V5.57h6.427v1.427a.714.714 0 0 0 1.427 0V5.57h3.213c.393 0 .713.32.713.713v2.501z"
            }),
            /* @__PURE__ */ r("path", {
                fill: h,
                d: "M8.34 16.103h.426a4.11 4.11 0 0 0 4.04 3.392c.719 0 1.427-.192 2.053-.553a.712.712 0 1 0-.713-1.235 2.675 2.675 0 0 1-3.918-1.604h2.757a.714.714 0 0 0 0-1.426H10.23a2.685 2.685 0 0 1 2.578-1.966c.466 0 .928.123 1.34.361a.717.717 0 0 0 .717-1.239 4.1 4.1 0 0 0-2.053-.553 4.11 4.11 0 0 0-4.04 3.392h-.426a.714.714 0 0 0-.713.713c0 .393.315.718.709.718"
            })
        ]
    }));
}, p = V;
export { p as default };
